<template>
  <div class="login-card">
    <div class="login-card-header">
      <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon>
      <span>Esqueci minha senha</span>
    </div>
    <div class="login-card-body">
      <form @submit.prevent="onSubmit">
        <div class="alert alert-success" v-show="msg.success">
          <font-awesome-icon :icon="['fas', 'check-circle']"></font-awesome-icon>
          Se o e-mail estiver cadastrado, você receberá as instruções para redefinir a senha.
        </div>
        <div class="alert alert-danger" v-show="msg.error">
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']"></font-awesome-icon>
          {{ msg.error }}
        </div>

        <div class="form-group">
          <label>Insira seu e-mail</label>
          <input
            type="text"
            class="form-control"
            v-model="user.email"
            placeholder="E-mail"
            autofocus
          />
        </div>

        <div class="d-flex justify-content-between align-items-center mt-2">
          <button type="button" class="btn btn-sm btn-secondary" @click="goBack()">
            <font-awesome-icon :icon="['fa', 'arrow-left']"></font-awesome-icon>
            Voltar
          </button>
          <button type="submit" class="btn-login">
            <font-awesome-icon :icon="['fa', 'paper-plane']"></font-awesome-icon>
            Enviar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { ref } from 'vue'
  import { useRouter } from 'vue-router'
  import axios from 'axios'

  export default {
    setup() {
      const router = useRouter()
      const user = ref({
        email: '',
      })
      const msg = ref({
        success: false,
        error: ''
      })

      const onSubmit = () => {
        var credentials = {
          email: user.value.email
        }

        msg.value.success = false
        msg.value.error = ''

        axios.post('api/recoveryPasswordMail', credentials)
          .then((response) => {
            if (response?.status === 200) {
              msg.value.success = true
            }
          })
          .catch((error) => {
            const status = error?.response?.status
            if (status === 429) {
              msg.value.error = 'Muitas tentativas. Aguarde um minuto e tente novamente.'
            } else if (status === 422) {
              msg.value.error = 'Informe um e-mail válido.'
            } else {
              msg.value.error = 'Não foi possível enviar agora. Tente novamente em instantes.'
            }
          })
      }

      return {
        router,
        onSubmit,
        user,
        msg,
      }
    },
    methods: {
      goBack() {
        this.router.push('/login');
      },
    }
  }
</script>
